document.addEventListener('DOMContentLoaded', function() {
  initNavbar();
  initMobileMenu();
  initHeroVideos();
  initLightbox();
  initScrollReveal();
  initCategoryFilters();
});

function initNavbar() {
  const navbar = document.querySelector('.navbar');
  if (!navbar) return;
  window.addEventListener('scroll', () => {
    navbar.classList.toggle('scrolled', window.scrollY > 50);
  });
}

function initMobileMenu() {
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close');
  const mobileLinks = document.querySelectorAll('.mobile-menu-link');
  if (!mobileToggle || !mobileMenu) return;
  mobileToggle.addEventListener('click', () => {
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  if (mobileClose) {
    mobileClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
}

function initHeroVideos() {
  const heroContainer = document.querySelector('.hero-video-container');
  if (!heroContainer) return;
  const videos = heroContainer.querySelectorAll('.hero-video');
  if (videos.length === 0) return;
  let currentVideoIndex = 0;
  let glitchActive = false;
  videos.forEach(video => {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
  });
  if (videos[0]) {
    videos[0].classList.add('active');
  }
  function triggerGlitch() {
    glitchActive = true;
    let cutsCount = 0;
    const maxCuts = Math.floor(Math.random() * 4) + 2;
    const cutInterval = setInterval(() => {
      if (videos[currentVideoIndex]) {
        videos[currentVideoIndex].classList.remove('active');
      }
      let next;
      do {
        next = Math.floor(Math.random() * videos.length);
      } while (next === currentVideoIndex && videos.length > 1);
      currentVideoIndex = next;
      if (videos[currentVideoIndex]) {
        videos[currentVideoIndex].classList.add('active', 'glitch');
      }
      cutsCount++;
      if (cutsCount >= maxCuts) {
        clearInterval(cutInterval);
        glitchActive = false;
        if (videos[currentVideoIndex]) {
          videos[currentVideoIndex].classList.remove('glitch');
        }
      }
    }, 150);
  }
  setInterval(() => {
    if (Math.random() > 0.3 && !glitchActive) {
      triggerGlitch();
    }
  }, 4000);
}

function initLightbox() {
  const lightbox = document.getElementById('lightbox');
  if (!lightbox) return;
  const lightboxImage = lightbox.querySelector('.lightbox-image');
  const lightboxClose = lightbox.querySelector('.lightbox-close');
  const triggers = document.querySelectorAll('[data-lightbox]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const imageSrc = trigger.dataset.lightbox || trigger.querySelector('img')?.src;
      if (imageSrc) {
        lightboxImage.src = imageSrc;
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
  });
  function closeLightbox() {
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { lightboxImage.src = ''; }, 300);
  }
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
  if (lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('open')) {
      closeLightbox();
    }
  });
}

function initScrollReveal() {
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length === 0) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(reveal => observer.observe(reveal));
}

function initCategoryFilters() {
  const filters = document.querySelectorAll('.category-filter');
  const products = document.querySelectorAll('.product-card');
  if (filters.length === 0 || products.length === 0) return;
  filters.forEach(filter => {
    filter.addEventListener('click', () => {
      const category = filter.dataset.category;
      filters.forEach(f => f.classList.remove('active'));
      filter.classList.add('active');
      products.forEach(product => {
        const productCategory = product.dataset.category || '';
        if (category === 'all' || productCategory.includes(category)) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
    });
  });
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    if (href === '#') return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
